import { createPortal } from 'react-dom';
import type { ReactNode } from 'react';

/**
 * Something that covers the page, rendered outside it.
 *
 * A sheet used to be rendered where it was opened from — inside the page,
 * inside the stage's own scroller. On iOS that is not a place a fixed
 * element can cover the window from: Safari paints a fixed descendant of a
 * scrolling box inside that box's layer, so the search strip above the
 * scroller, at a lower z-index, was drawn over the sheet's header, and the
 * close button under it could not be reached. Chromium happened to get it
 * right, which is why it was not seen here first.
 *
 * So anything modal is carried to the body, beside the app rather than
 * inside it. React context and events still reach it through the portal;
 * only the DOM position changes, and with it every stacking context, scroll
 * container and transform between the page and the window.
 */
export function Layer({ children }: { children: ReactNode }) {
  return createPortal(children, document.body);
}
